import { Navigate, Outlet, useLocation } from "react-router-dom";
import { usePageStateStore } from "@/reducers";

import { useAuth } from "@/contexts/auth-context";

export const ProtectedRoute = () => {
  const { isAuth, loading } = useAuth();
  const location = useLocation();
  const authToken = usePageStateStore.use.authToken() || "";
  const setProtectedRouteRedirectPath = usePageStateStore.use.setProtectedRouteRedirectPath();

  // If not authenticated,  then save redirected link to localStorage
  if (!authToken) {
    setProtectedRouteRedirectPath(location.pathname.replace("/", ""));
  }

  if (loading) {
    return <div data-testid="container-protectedroute-loading">Account loading...</div>;
  }

  return isAuth ? (
    <Outlet />
  ) : (
    <Navigate to="/EasyLogin" replace state={{ from: location }} />
  );
};

// Suggestions
// 1. Consider adding a loading spinner or skeleton UI instead of just text for better UX during loading state
// 2. Add error handling for authentication failures
// 3. Extract the conditional rendering logic into separate components for better readability
